
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyFuel as ObiEnergyFuelElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-fuel.js';
 
 
 

 
 export const ObiEnergyFuel = createComponent({
   react: React,
   tagName: 'obi-energy-fuel',
   elementClass: ObiEnergyFuelElement,
   events: {
     
   }
  });
 
 